// extracted by mini-css-extract-plugin
module.exports = {"dynamic":"PageContentWrapper_dynamic__23pyC","container":"PageContentWrapper_container__8iEvL","containerPadding":"PageContentWrapper_containerPadding__2bSf4"};